<div class="dialog-content">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-grid gap-14">
    <div class="form-group">
      <app-input
        context="Normal"
        class="form-item"
        label="Event type name"
        placeholder="Enter your event type name"
        type="text"
        [control]="form.get('eventTypeName')"
        formControlName="eventTypeName"
        [required]="true"
        [customErrorMessages]="customErrorMessages.eventTypeName"
        [attr.disabled]="isEventTypeNameDisabled() ? true : null"
      >
      </app-input>
    </div>
    <div class="grid-container">
      <div class="form-group">
        <app-input
          context="Normal"
          label="Points method"
          placeholder="Select points method"
          type="select"
          [control]="form.get('pointsMethod')"
          [options]="pointsMethod"
          [required]="true"
          [customErrorMessages]="customErrorMessages.pointsMethod"
        >
        </app-input>
      </div>
      <div class="form-group">
        <app-input
          context="Normal"
          class="form-item"
          label="PD points"
          placeholder="Enter your points (eg. 1000)"
          type="text"
          [control]="form.get('pointsAwarded')"
          [required]="true"
          formControlName="pointsAwarded"
          [customErrorMessages]="customErrorMessages.pointsAwarded"
        >
        </app-input>
      </div>
    </div>

    <div class="image-grid">
      <div class="d-grid gap-2 text-image">
        Event type image
        <div class="image-selection-container">
          <div class="image-preview" *ngIf="selectedImage">
            <div class="preview-container">
              <img
                [src]="selectedImage.imagePath || selectedImage"
                alt="Selected image"
                class="preview-image"
              />
              <button
                type="button"
                class="remove-image-btn"
                (click)="removeSelectedImage()"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4L4 12"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M4 4L12 12"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <button
            type="button"
            class="add-img-btn"
            (click)="openGallery()"
            *ngIf="!selectedImage"
          >
            <img class="upload-icon" src="assets/images/image-add.svg" />Add
            image
          </button>

          <!-- Conditionally show error message -->
          <div class="error-message" *ngIf="isImageInvalid() && isImageTouched">
            Please select an event type image
          </div>
        </div>
      </div>

      <div>
        <app-input
          context="Normal"
          class="form-item"
          label="Image description"
          placeholder="Enter image description"
          type="textarea"
          [control]="form.get('eventTypeImageDescription')"
          [required]="false"
          lineRow="6"
          formControlName="eventTypeImageDescription"
          [customErrorMessages]="customErrorMessages.eventTypeImageDescription"
        >
        </app-input>
      </div>
    </div>

    <button type="submit" style="display: none" #submitBtn></button>
  </form>
</div>
